var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('header',{staticClass:"header-card"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('ajoutEditContrat.pj.title'))+" ")])]),_c('div',{staticClass:"card-content"},[_c('piecesJointes',{attrs:{"checkPermissions":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }